import { Platform, StyleSheet } from "react-native";
import { theme } from "../../../theme/theme";
const style = () => {
    const { colorText, colorTextMedium, fontMap, fontInputSize, fontInputPaddingRight, fontInputLetterSpacing, space3 } = theme();
    const styles = StyleSheet.create({
        container: {
            ...Platform.select({
                web: {
                    paddingHorizontal: fontInputPaddingRight,
                },
                android: {
                    paddingLeft: space3,
                    paddingRight: fontInputPaddingRight,
                },
                ios: {
                    paddingHorizontal: fontInputPaddingRight,
                },
            }),
        },
        input: {
            color: colorText,
            flex: 1,
            fontFamily: fontMap.Body,
            fontSize: fontInputSize,
            height: "100%",
            letterSpacing: fontInputLetterSpacing,
            minWidth: 0,
            ...Platform.select({
                web: {
                    outlineStyle: "none",
                },
            }),
        },
    });
    return {
        ...styles,
        placeholderTextColor: colorTextMedium,
    };
};
export { style };
